React = require 'react/addons'
Reflux = require 'reflux'
AgeVerification = require '../actions/age-verification'

module.exports = AgeStore = Reflux.createStore
  listenables: AgeVerification

  init: ->
    @ageVerification = localStorage.getItem 'ageVerification'

  onAgeVerification: (payload) ->
    @ageVerification = payload.valid
    @trigger { ageVerification: payload.valid }

  onReset: (payload) ->
    @ageVerification = null
    @trigger { ageVerification: null }

AgeStore.listen (payload) ->
  localStorage.setItem 'ageVerification', payload.ageVerification



/** WEBPACK FOOTER **
 ** ./src/scripts/stores/age-store.coffee
 **/